module.exports = import("https://esm.sh/moment");;